import { render } from "./agent-brokerage.vue?vue&type=template&id=12d7c294"
import script from "./agent-brokerage.js?vue&type=script&lang=js"
export * from "./agent-brokerage.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__